const parser = typeof DOMParser !== "undefined" ? new DOMParser() : null;

/**
 * Strips markup from a rich-text value and returns the plain text.
 *
 * Uses DOMParser rather than assigning to innerHTML: an inert document does
 * not run `<img onerror>` and does not fetch the resources it references,
 * which matters because the input is stored content authored elsewhere.
 */
export function htmlToText(html) {
    if (!html) {
        return "";
    }

    const value = String(html);

    if (!parser) {
        return value.replace(/<[^>]*>/g, "").trim();
    }

    const parsed = parser.parseFromString(value, "text/html");
    return (parsed.body.textContent || "").trim();
}

export default { htmlToText };
